function refreshJwtToken() {
    const matches = /[?&]token=(.*?)(&|$)/.exec(location.href) || [];
    if (matches[1]) {
        window.sessionStorage.setItem('jwtToken', matches[1]);
    }
    return matches[1];
}

refreshJwtToken();

export function getJwtToken() {
    return window.sessionStorage.getItem('jwtToken');
}

export function clearJwtToken() {
    window.sessionStorage.removeItem('jwtToken');
}